import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {crearHash} from "../Funciones/crearHash";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {adap_deposito_mov} from "../Adaptadores/adap_deposito_mov";
import {obtenerValorPorcentaje} from "../Funciones/obtenerValorPorcentaje";

export const pagarFeeDeposito = async ({entidad, usuario, desde}) => {


    entidad.fecha = new Date().getTime()
    entidad.idUsuario = usuario.id
    entidad.nombre = usuario.nombre
    entidad.codigoUsuario = usuario.codigo
    entidad.correo = usuario.correo

    let consecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
    entidad.consecutivo = consecutivo.data


    let img = await subirImagenHostingFile(entidad.img)
    entidad.img = img.data
    entidad.hashString = JSON.stringify(entidad)
    entidad.hash = crearHash({text: entidad.hashString})
    entidad.estado = 'Aceptado' //Aceptado por que pasa
    entidad.realizo = 'Usuario'
    entidad.detalle = `Pago Fee 5% de retiro de ${desde}`

    let fee = obtenerValorPorcentaje({total: entidad.valor, porcentaje: 5})
    entidad.valor = fee * -1

    let doxTrans = await registrarMovimiento({movimiento: adap_deposito_mov(entidad, entidad.valor), estado: 'Aceptado'})
    if (doxTrans) {
        await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: entidad.consecutivo})
        return true
    } else {
        return false
    }
}